import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { format, addDays, subDays, differenceInDays, differenceInMonths, differenceInYears } from 'date-fns';
import { getScheduleDate } from '@/store/selectors/schedule';

import DateInfoComponent from './DateInfoComponent';

const DateInfoContainer = () => {
  const date = useSelector(getScheduleDate);

  const intl = useIntl();

  const pattern = 'yyyyMMdd';

  // garante que é Date
  const currentDate = date instanceof Date ? date : new Date(date);
  const now = new Date();

  const selectedDate = format(currentDate, pattern);
  const today = format(now, pattern);
  const yesterday = format(subDays(now, 1), pattern);
  const tomorrow = format(addDays(now, 1), pattern);
  const afterTomorrow = format(addDays(now, 2), pattern);
  const beforeYesterday = format(subDays(now, 2), pattern);

  const diffDateDays = differenceInDays(currentDate, now);
  const diffDateMonths = differenceInMonths(currentDate, now);
  const diffDateYears = differenceInYears(currentDate, now);

  let label = '';

  if (today === selectedDate) {
    label = intl.formatMessage({ id: 'TODAY' });
  } else if (yesterday === selectedDate) {
    label = intl.formatMessage({ id: 'YESTERDAY' });
  } else if (tomorrow === selectedDate) {
    label = intl.formatMessage({ id: 'TOMORROW' });
  } else if (afterTomorrow === selectedDate) {
    label = intl.formatMessage({ id: 'AFTER_TOMORROW' });
  } else if (beforeYesterday === selectedDate) {
    label = intl.formatMessage({ id: 'BEFORE_YESTERDAY' });
  } else if (diffDateDays > 2 && diffDateDays <= 30) {
    label = intl.formatMessage({ id: 'IN_DAYS' }, { days: diffDateDays });
  } else if (diffDateDays < -2 && diffDateDays >= -30) {
    label = intl.formatMessage({ id: 'DAYS_AGO' }, { days: diffDateDays * -1 });
  } else if (diffDateMonths === 1) {
    label = intl.formatMessage({ id: 'IN_MONTH' });
  } else if (diffDateMonths > 1 && diffDateMonths <= 11) {
    label = intl.formatMessage({ id: 'IN_MONTHS' }, { months: diffDateMonths });
  } else if (diffDateMonths === -1) {
    label = intl.formatMessage({ id: 'MONTH_AGO' });
  } else if (diffDateMonths < -1 && diffDateMonths >= -11) {
    label = intl.formatMessage({ id: 'MONTHS_AGO' }, { months: diffDateMonths * -1 });
  } else if (diffDateYears === 1) {
    label = intl.formatMessage({ id: 'IN_YEAR' });
  } else if (diffDateYears > 1) {
    label = intl.formatMessage({ id: 'IN_YEARS' }, { years: diffDateYears });
  } else if (diffDateYears === -1) {
    label = intl.formatMessage({ id: 'YEAR_AGO' });
  } else if (diffDateYears < -1) {
    label = intl.formatMessage({ id: 'YEARS_AGO' }, { years: diffDateYears * -1 });
  }

  return <DateInfoComponent date={currentDate} label={label} />;
};

export default DateInfoContainer;
